import type { ReactElement } from 'react';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { BannerNotification } from 'feature-components/notification';
import Sidebar from 'feature-components/sidebar/sidebar';
import { useNotifications } from 'services/assist-api/entities/notification/check';
import PageAccessProvider from 'services/providers/page-access.provider';
import './index.scss';

export default function AuthenticatedLayout(): ReactElement {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const notifications = useNotifications({ filters: { location: 'banner' } });

  return (
    <PageAccessProvider>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="content-wrapper">
        {!!notifications.data?.json && (
          <div className="notification-list d-print-none">
            {notifications.data?.json.map((notification) => (
              <BannerNotification key={notification.id} notification={notification} />
            ))}
          </div>
        )}
        <Outlet />
      </div>
    </PageAccessProvider>
  );
}
